<app-header></app-header>
<div class="app-content visitor-pages">
					<div class="side-app ">
						<div class="row">
                              <div class="col-md-12 col-lg-12">
								<div class="">
									<!-- <div class="card-header">
										<h3 class="card-title">Carousel with controls</h3>
									</div> -->
									<div class="card-body">
										<div id="defaultCarousel23" class="owl-carousel Card-owlcarousel owl-carousel-icons-vis">
											
												<!-- <div class="carousel-item active">
												    <div class="backgrouimg"></div>
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-showroom-2.jpg" data-holder-rendered="true">-->
													<!-- <p>Marketplace to discover the best Cars </p> -->
												<!-- </div> -->
											<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/marsidi.jpg); background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
												
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/vehicle-banner.png);  background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
													
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												
												<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/gogoa-banner2.jpg);  background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												
												<!-- <div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<!-- <div class="backgrouimg1 " style="background: url(assets/images/banners/swift.png);  background-repeat: no-repeat; background-position: center; background-size: cover;"></div>
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>  -->
												
												<div class="item ">
													<!--<img class="d-block w-100" alt="" src="assets/images/banners/car-show1.jpg" data-holder-rendered="true">-->
												<div class="backgrouimg1 " style="background: url(assets/images/banners/Luxury-cars1.jpg); background-repeat: no-repeat; background-position: top; background-size: cover;"></div>
													<p>Best <span class="color-size"> Okshan </span>  place to Sell or Buy Cars</p>
													<div class=" btn-rew">
													<span class="subline">B2B market place for Our Associates Only </span>
														<div class="col-md-12">
														<a href="javascript:void(0)" class="request_tour1"    data-toggle="modal" data-target="#exampleModal4"><span>Request a Tour </span></a>
														</div>
													</div>
												</div>
												
												
											</div>
											<!-- <a class="carousel-control-prev" href="#carousel-controls" role="button" data-slide="prev">
												<span class="carousel-control-prev-icon" aria-hidden="true"></span>
												<span class="sr-only">Previous</span>
											</a>
											<a class="carousel-control-next" href="#carousel-controls" role="button" data-slide="next">
												<span class="carousel-control-next-icon" aria-hidden="true"></span>
												<span class="sr-only">Next</span>
											</a> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					
				</div>
        <!--/Breadcrumb-->

         <!--Section-->
        <div id="howItWorks">
         <section class="sptb  bg-white how-its-work-se">
           
                <div id="defaultCarousel" class="owl-carousel Card-owlcarousel owl-carousel-icons-vis">
			<div class="item">
				 <div class="container">
                <div class="section-title center-block text-center">
                    <h2>How it Works for Buyers </h2>
                    
                </div>
				<div class="d-md-flex">
                   
                        <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">Browse fresh inventory </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/search.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">View detail inspection report </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Inspection.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4 class=" mb-0 olw-header">Make an offer </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Vehicleview.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
                        </div>
                        
                    </div>
                   
                </div>				
				
				<div class="item">
				 <div class="container">
                <div class="section-title center-block text-center">
                    <h2>How it Works for Sellers  </h2>
                    
                </div>
				<div class="d-md-flex">
                   
                        <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">Upload your car for sale </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/search.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4  class=" mb-0 olw-header">Get free inspection  </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Inspection.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
						 <div class=" mb-0  col-md-4">
                            
                            <div class="card-body p-4 ">
                                <div class="heading-text">
                                   
                                <h4 class=" mb-0 olw-header">Get Offers </h4>
                                
                            </div>
							<div class="item7-card-img">
                                <a ></a>
                                <img src="assets/images/brand/Vehicleview.png" alt="img" class="cover-image">
                            </div>
                        </div>
                        </div>
                        </div>
                        
                    </div>
                   
                </div>
				
            </div>            
        </section>
        </div>
        <!--Section-->

        

        <!--section-->
        <section class="sptb chose-us-sec ">
            <div class="container">
                <div class="section-title center-block text-center">
                    <h2>Why Choose Us?</h2>
                </div>
                <div class="row ">
                    <div class="col-md-6 col-lg-3 features">
                        
                                <div class="feature">
                                    <div class="img-cener">
                                        <img src="assets/images/visitor/car.png">
                                    </div>
                                    <p>Extensive range of used car inventory</p>
                                </div>
							</div>
                        <div class="col-md-6 col-lg-3 features">
						<div class="feature">
							<div class="img-cener">
								<img src="assets/images/visitor/money.png"> </div>
                                    
									<p>Transparent deals</p>
                                   
                                
                        </div>
                    </div>    
						<div class="col-md-6 col-lg-3 features">
							<div class="feature">
                                     <div class="img-cener">
                                        <img src="assets/images/visitor/wrench.png">
                                    </div>
                                   
                                    <p>Okshan verified cars, detail inspection report</p>
                                </div>
							</div>                    
                    <div class="col-md-6 col-lg-3 features">
                       
                                <div class="feature">
                                     <div class="img-cener">
                                        <img src="assets/images/visitor/distance.png">
                                    </div>
                                    <p>Fully online deals across the country</p>
                                  </div>
                            
                    </div>
                   
                    
                </div>
            </div>
        </section>
        <!--/section-->

       
        <!--section-->
       <section class="sptb bg-white our-team-sec">
            <div class="container">
                <div class="section-title center-block text-center">
                    <h2>What our Associates Say </h2>
                  
                </div>
                <div class="row">
                    <div id="feature-carousel" class="owl-carousel owl-carousel-assoc-fix auction-content">
                    
                    <div class="item" *ngFor="let testimonial of testimonialList">
                    <div class="col-xl-12 col-md-12">
                        <div class="card mb-0 box-shadow2">
                            <div class="card-body">
                                <div class="team-section text-center">
                                    <div class="team-img">
                                         <img src="{{fileUrl+testimonial.image}}" class="img-thumbnail rounded-circle"  alt="">
                                    </div>
                                    <h4 class="font-weight-bold dark-grey-text mt-4">{{testimonial.user_name}}</h4>
                                    <h4 class="font-weight-bold dark-grey-text mt-4">{{testimonial.trade_name}}</h4>
                                   
                                    <p class="font-weight-Automatic dark-grey-text">
                                        <i class="fa fa-quote-left pr-2"></i>{{testimonial.message}} <i class="fa fa-quote-right pr-2"></i>
                                    </p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
        <!--/section-->	

        
        
        <app-footer></app-footer>